import slugify from "slugify";

export default function FormSelect({
  label,
  value,
  disabled = false,
  required = false,
  error = false,
  options = [],
  description,
  ...params
}) {
  const identifier = slugify(label);

  return (
    <div className={`FormInput ${error ? "has-error" : ""}`}>
      <label className="FormLabel" htmlFor={identifier}>
        {label}
        {required && <span title="Pflichtfeld">*</span>}
      </label>
      <select
        className="Select"
        name={identifier}
        disabled={disabled}
        {...params}
        value={value}
      >
        {!value && <option value={null} selected />}
        {options.map((option) => (
          <option className="text-base" value={option.value} key={option.value}>
            {option.text}
          </option>
        ))}
      </select>
      {description && (
        <p className="FormDescription" id={`${identifier}-description`}>
          {description}
        </p>
      )}
    </div>
  );
}
